
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Create an instance of axios with default settings
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the token in the headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("userToken");

    if (token) {
      config.headers["x-access-token"] = token; // Set the token in the header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// Get membertypes API function
export const getAllCommunityMemberTypes = async (payload) => {
  try {
    const response = await axiosInstance.post("/getAllCommunityMemberTypes", payload);
    return response.data;
  } catch (error) {
    console.error("getAllCommunityMemberTypes API Error:", error);
    throw error;
  }
};
 // Request for new comminites
export const createCommunity = async (payload) => {
  try {
    const response = await axiosInstance.post("/createCommunity", payload);
    return response.data;
  } catch (error) {
    console.error("createCommunity API Error:", error);
    throw error;
  }
};

export const joinCommunity = async (payload) => {
  try {
    const response = await axiosInstance.post("/joinCommunity", payload);
    return response.data;
  } catch (error) {
    console.error("joinCommunity API Error:", error);
    throw error;
  }
};






